import React from 'react';
import { createRoot } from 'react-dom/client';
import { SeatsChart } from './SeatedPlan';
import { pricingMagic } from './utils';
import { validateLanguage } from './types';
import { EventManagerElement } from './EventManager';
import { SeatsAvailabilityBar } from './SeatedAvailabilityBar';

document.addEventListener('DOMContentLoaded', () => {
  const seatedPlanRootElement = document.getElementById('seatedPlanDiv');
  if (seatedPlanRootElement) {
    const root = createRoot(seatedPlanRootElement);

    const seatsioSeatingCharVars = window.seatsioSeatingCharVars;
    if (!seatsioSeatingCharVars) {
      root.render(
        <div>
          <p>
            <strong>Error:</strong> The required variables for the Seats.io seating chart are not
            defined.
          </p>
          <p>Please ensure that the necessary configuration is provided in the global variable.</p>
        </div>,
      );
    } else {
      const {
        workspaceKey,
        eventId,
        pricing,
        language,
        currencySymbol,
        ticketsMaxQtys = {},
        showLegend = true,
        showCategoryName = false,
      } = {
        ...seatsioSeatingCharVars,
        pricing: pricingMagic(false, [], seatsioSeatingCharVars.ticketsMaxQtys || {}),
        language: validateLanguage(seatsioSeatingCharVars.language),
      };
      root.render(
        <SeatsChart
          pricing={pricing}
          workspaceKey={workspaceKey}
          eventId={eventId}
          currencySymbol={currencySymbol}
          language={language}
          showLegend={showLegend}
          showCategoryName={showCategoryName}
          ticketsMaxQtys={ticketsMaxQtys}
        ></SeatsChart>,
      );
    }
  }

  const eventManagerRootElement = document.getElementById('eventManagerDiv');

  if (eventManagerRootElement) {
    const managerRoot = createRoot(eventManagerRootElement);
    const seatsioSeatingCharVars = window.seatsioSeatingCharVars;
    if (!seatsioSeatingCharVars) {
      managerRoot.render(
        <div>
          <p>
            <strong>Error:</strong> The required variables for the Seats.io seating chart are not
            defined.
          </p>
          <p>Please ensure that the necessary configuration is provided in the global variable.</p>
        </div>,
      );
    } else {
      const { workspaceKey, eventId, language } = {
        ...seatsioSeatingCharVars,
        language: validateLanguage(seatsioSeatingCharVars.language),
      };

      managerRoot.render(
        <EventManagerElement workspaceKey={workspaceKey} eventId={eventId} language={language} />,
      );
    }
  }
  const seatedAvailabilityBarElement = document.getElementById('seatedAvailabilityBar');

  if (seatedAvailabilityBarElement) {
    const seatedAvailabilityBarRoot = createRoot(seatedAvailabilityBarElement);
    const seatsioSeatingCharVars = window.seatsioSeatingCharVars;
    if (!seatsioSeatingCharVars?.seatsAvailability) {
      seatedAvailabilityBarRoot.render(
        <div>
          <p>
            <strong>Error:</strong> The required variables for the Seats.io seating availability
            chart are not defined.
          </p>
          <p>Please ensure that the necessary configuration is provided in the global variable.</p>
        </div>,
      );
    } else {
      seatedAvailabilityBarRoot.render(
        <SeatsAvailabilityBar data={seatsioSeatingCharVars.seatsAvailability} />,
      );
    }
  }
});
